module.exports = __webpack_public_path__ + "static/media/avatar3.6002e80e.png";